import React from "react";
import { motion } from "framer-motion";

const ResizeChild = ({ children, direction, variants, childRef }) => {
  return (
    <motion.div
      ref={childRef}
      className="wrapper"
      initial="enter"
      animate="animate"
      exit="exit"
      transition={{
        duration: 1,
        x: { type: "spring", stiffness: 300, damping: 30 },
      }}
      style={{
        position: "absolute",
        width: "max-content",
      }}
      custom={direction}
      variants={variants}
    >
      {children}
    </motion.div>
  );
};

export default ResizeChild;
